import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If callback state provided user, allow through immediately
  if (location.state?.user) return children;

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F4EFE7] flex items-center justify-center">
        <div className="text-[#1E1B18]/60 text-sm tracking-[0.2em]">LOADING…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;
  return children;
};

export default ProtectedRoute;
